<template>
  <div class="wap_game_single">
    <div class="wap_game_single_box">
      <div class="wap_index6_title">
        <div>游戏专区</div>
      </div>
      <div class="wap_game_single_nav" ref="wap_game_single_nav">
        <div class="wap_game_single_nav_ul">
          <div @click="wapgameSingle(index)" v-for="(item, index) in wapgameSinglelist" :key="index"
            :class="item.show ? 'nav_ul_activate' : ''">
            {{ item.title }}
          </div>
          <div class="wap_game_single_wire"></div>
        </div>
      </div>
      <div class="wap_game_single_swiper_info">
        <div class="" ref="wap_game_single_info">
          <div v-if="wapgameSingindex < 3">
            <div class="wap_game_single_swiper_info_ul">
              <div class="wap_game_single_swiper_info_li" @click="tolink(li)" v-for="(li, liIndex) in wapgameSinglelist[wapgameSingindex]
                .list1" :key="liIndex">
                <div class="" :style="{
                  background: 'url(' + li.phone_img + ') no-repeat center',
                }"></div>
                <div class="">{{ li.name }}</div>
                <div class="">
                  <div v-for="(des, desindex) in li.describe" :key="desindex">
                    {{ des }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wap_game_single_swiper_info_ul">
              <div class="wap_game_single_swiper_info_li" @click="tolink(li)" v-for="(li, liIndex) in wapgameSinglelist[wapgameSingindex]
                .list2" :key="liIndex">
                <div class="" :style="{
                  background: 'url(' + li.phone_img + ') no-repeat center',
                }"></div>
                <div class="">{{ li.name }}</div>
                <div class="">
                  <div v-for="(des, desindex) in li.describe" :key="desindex">
                    {{ des }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="wapgameSingindex == 3">
            <!-- banner -->
            <div class="swiper wap_xxindex_box">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(arr2D, index2D) in wapgameSinglelist[wapgameSingindex].list1"
                  :key="index2D">
                  <div @click="tolink(item)" class="wap_game_single_special"
                    v-for="(item, index) in arr2D" :key="index">
                    <div class="wap_game_single_special_left" :style="{
                      background: 'url(' + item.phone_img + ') no-repeat center',
                    }"></div>
                    <div class="wap_game_single_special_right">
                      <div>{{ item.name }}</div>
                      <div>
                        {{ item.desc }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertTo2DArray, slicing2DArray } from "@/utils/index";
import { mapState } from 'vuex';
import { downloadA } from '@/utils/download'
import { customText } from '@/utils/key'
export default {
  data() {
    return {
      mySwiperbox1: null,
      wapgameSingindex: 0,
      wapgameSinglelist: [
        {
          title: "近期测试",
          show: true,
          list1: [],
          list2: [],
        },
        {
          title: "正版授权游戏",
          show: false,
          list1: [],
          list2: [],
        },
        {
          title: "违规游戏公示",
          show: false,
          list1: [],
          list2: [],
        },
        {
          title: "最新资讯",
          show: false,
          list1: [],
        },
      ],
    };
  },
  created() {

  },
  mounted() {

  },
  computed: {
    ...mapState({
      speciallyGameList: (state) => state.init.speciallyGameList,
    })
  },
  watch: {
    speciallyGameList: {
      handler(val) {
        let arr = []
        for (const key in val) {
          let list = val[key];
          list.forEach(item => {
            item.show = false
            if (key != 'list4') {
              item.describe = [
                `版本：${item.cate_name}`,
                `上线时间：${item.online_time}`,
                `最新开服时间:${item.open_time}`,
                `官网：${item.url}`
              ]
            }
          })
        }
        this.wapgameSinglelist[0].list1 = slicing2DArray(val.list1)[0]
        this.wapgameSinglelist[0].list2 = slicing2DArray(val.list1)[1]

        this.wapgameSinglelist[1].list1 = slicing2DArray(val.list2)[0]
        this.wapgameSinglelist[1].list2 = slicing2DArray(val.list2)[1]

        this.wapgameSinglelist[2].list1 = slicing2DArray(val.list3)[0]
        this.wapgameSinglelist[2].list2 = slicing2DArray(val.list3)[1]

        this.wapgameSinglelist[3].list1 = convertTo2DArray(val.list4, 5)
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    tolink(item) {
      
      switch (item.type) {
        case 1:
          downloadA(item.url)
          break;
        case 2:
          if (item.content) {
            localStorage.setItem(customText, item.content);
            let href = window.location.href
            window.open(`${href}custom`)
          }
          break;
        case 3:
          if (item.url) {
            this.$router.push({
              path: item.url,
            })
          }
          break;
        default:
          break;
      }
    },
    homeSwiper() {
      this.mySwiperbox1 = new Swiper(".wap_xxindex_box", {
        autoplay: true, //可选选项，自动滑动
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 30000000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          clickableClass: "my-pagination-clickable",
        },
        loop: true,
        centeredSlides: true,
      });
    },
    wapgameSingle(index) {
      let special = document.querySelector(".wap_game_single_wire");
      let navWidth = document.querySelector(
        ".wap_game_single_wire"
      ).clientWidth;
      let liWidth = document.querySelector(".wap_game_single_nav_ul").children[
        index
      ].clientWidth;
      let left =
        document.querySelector(".wap_game_single_nav_ul").children[index]
          .offsetLeft -
        (navWidth - liWidth) / 2;
      if (index >= 2) {
        this.$refs.wap_game_single_nav.scrollLeft = index * 80;
      } else {
        this.$refs.wap_game_single_nav.scrollLeft = 0;
      }
      special.style.transform = `translateX(${left}px)`;
      this.$refs.wap_game_single_info.scrollLeft = 0;
      this.wapgameSingindex = index;
      if (this.wapgameSingindex == 3) {
        this.$nextTick(() => {
          this.homeSwiper();
        })
      }
      this.wapgameSinglelist.forEach((item) => {
        item.show = false;
      });
      this.wapgameSinglelist[index].show = true;
    },
  },
};
</script>

<style scoped lang="scss">
/* 游戏专区 */
.wap_game_single {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/web/game_bg.png") no-repeat center;
  background-size: cover;
}

.wap_game_single_box {
  width: 90%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.wap_game_single_nav {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.wap_game_single_wire {
  position: absolute;
  left: 0;
  bottom: -0.026667rem
    /* 1/37.5 */
  ;
  width: 1.813333rem
    /* 68/37.5 */
  ;
  height: 0.053333rem
    /* 2/37.5 */
  ;
  background: #ff0e0e;
  transform: translateX(0);
  transition: transform 500ms cubic-bezier(0.48, 0.33, 0.24, 0.95) 0ms;
}

.wap_game_single_nav::-webkit-scrollbar {
  background-color: transparent;
}

.wap_game_single_nav_ul {
  display: flex;
  width: 120%;
  padding-bottom: 0.266667rem
    /* 10/37.5 */
  ;
  border-bottom: 0.053333rem
    /* 2/37.5 */
    solid #707070;
  position: relative;
}

.wap_game_single_nav_ul>div {
  flex-shrink: 0;
  color: #ffffff;
  margin-right: 0.773333rem
    /* 29/37.5 */
  ;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
}

.wap_game_single_swiper_info {
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
}

.wap_game_single_swiper_info>div {
  flex-shrink: 0;
  width: 100%;
  overflow-x: auto;
  padding-top: 0.533333rem
    /* 20/37.5 */
  ;
}

.wap_game_single_swiper_info_ul {
  display: flex;
}

.wap_game_single_swiper_info_ul:nth-child(1) {
  margin-bottom: 0.56rem
    /* 22/37.5 */
  ;
}

.wap_game_single_swiper_info_li {
  width: 4.88rem
    /* 183/37.5 */
  ;
}

.wap_game_single_swiper_info_li {
  margin-right: 0.533333rem
    /* 20/37.5 */
  ;
}

.wap_game_single_swiper_info_li>div:nth-child(1) {
  width: 4.88rem
    /* 183/37.5 */
  ;
  height: 3.306667rem
    /* 124/37.5 */
  ;
  border-radius: 0.106667rem
    /* 4/37.5 */
  ;
  background: url("../../assets/images/web/accordion-1.jpg") no-repeat center;
  background-size: cover !important;
}

.wap_game_single_swiper_info_li>div:nth-child(2) {
  padding-top: 0.266667rem
    /* 10/37.5 */
  ;
  padding-bottom: 0.32rem
    /* 12/37.5 */
  ;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  color: #fff;
}

.wap_game_single_swiper_info_li>div:nth-child(3) {
  color: #aaaaaa;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.32rem
    /* 12/37.5 */
  ;
  width: 4.88rem
    /* 183/37.5 */
  ;
}

.wap_xxindex_box {
  width: 100%;
  height: 96%;
  --swiper-theme-color: #fff;
  --swiper-pagination-color: #fff;

  /* 两种都可以 */
  .swiper-pagination-horizontal {
    bottom: 0px !important;
  }
}

.wap_game_single_special {
  display: flex;
  margin-bottom: 0.853333rem
    /* 32/37.5 */
  ;
  margin-bottom: .693333rem
    /* 26/37.5 */
  ;
}

.wap_game_single_special_left {
  width: 2.986667rem
    /* 112/37.5 */
  ;
  height: 1.68rem
    /* 63/37.5 */
  ;
  border-radius: 0.106667rem
    /* 4/37.5 */
  ;
  background: url("../../assets/images/web/box_info-6.png") no-repeat center;
  background-size: cover !important;
  margin-right: 0.346667rem
    /* 13/37.5 */
  ;
}

.wap_game_single_special_right {
  width: 5.866667rem
    /* 220/37.5 */
  ;
}

.wap_game_single_special_right>div:nth-child(1) {
  color: #ffffff;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  padding-bottom: 0.266667rem
    /* 10/37.5 */
  ;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.wap_game_single_special_right>div:nth-child(2) {
  color: #aaaaaa;
  font-size: 0.32rem
    /* 12/37.5 */
  ;
  height: 0.853333rem
    /* 32/37.5 */
  ;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

@media (max-width: 750px) and (max-height: 667px) {
  .wap_game_single_swiper_info_li>div:nth-child(1) {
    width: 3.813333rem
      /* 143/37.5 */
    ;
    height: 2.24rem
      /* 84/37.5 */
    ;
  }

  .wap_game_single_swiper_info_li>div:nth-child(2) {
    padding-top: 0.16rem
      /* 6/37.5 */
    ;
    padding-bottom: 0.16rem
      /* 6/37.5 */
    ;
    font-size: 0.373333rem
      /* 14/37.5 */
    ;
    color: #fff;
  }

  .wap_game_single_swiper_info_li>div:nth-child(3) {
    font-size: 0.266667rem
      /* 10/37.5 */
    ;
  }

  .wap_game_single_swiper_info_ul:nth-child(1) {
    margin-bottom: 0.293333rem
      /* 11/37.5 */
    ;
  }
}

@media (max-width: 750px) and (max-height: 600px) {
  .wap_game_single_swiper_info_li>div:nth-child(2) {
    padding-top: 0.08rem
      /* 3/37.5 */
    ;
    padding-bottom: 0.08rem
      /* 3/37.5 */
    ;
    font-size: 0.32rem
      /* 12/37.5 */
    ;
  }

  .wap_game_single_swiper_info_ul:nth-child(1) {
    margin-bottom: 0.186667rem
      /* 7/37.5 */
    ;
  }

  .wap_game_single_swiper_info>div {
    padding-top: 0.133333rem
      /* 5/37.5 */
    ;
  }
}
</style>
